module.exports = __webpack_public_path__ + "img/20200704_133926.9cbd807f.jpg";